import FullPageSyncLoader from './FullPageSyncLoader';

export default FullPageSyncLoader;
